// coverts 'x' to 'x', '{a: 'b'}' to 'a.b', '{a: { b: 'c'}}' to 'a.b.c' ...
import { ValueObject } from '../../Smartform';
import { ModelTarget } from '../../../types';

/*
 * Converts partial model object or string to a model path (string)
 * @param {string | number | ValueObject} v - partial model object
 * @param {boolean} useAsSchemaKey - adds `$` prefix to a path. Thus, formik is able to obtain a value from this location
 *
 * Input: 'personUid'
 * Output: 'personUid'
 *
 * Input: { engagement: 'uid' }
 * Output: 'engagement.uid'
 *
 * Input: { engagement: { worker: 'uid' } }
 * Output: 'engagement.worker.uid'
 */

export function objectToPath(v?: string | number | ValueObject, useAsSchemaKey = false): string {
  if (!v) {
    return '';
  }
  if (typeof v === 'string') {
    return v;
  }
  return (
    (useAsSchemaKey ? '$' : '') +
    Object.entries(v).reduce((acc, [key, value]) => {
      const additionalDot = acc && acc.charAt(acc.length - 1) !== '.' ? '.' : '';
      return `${acc + additionalDot + key}.${typeof value === 'string' ? value : objectToPath(value)}`;
    }, '')
  );
}

export function modelToPath(model: ModelTarget<string | object | number>, useAsSchemaKey = true): string {
  return objectToPath(model as ValueObject, useAsSchemaKey);
}
